import { ArrowExpandIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { handleAppLink } from './appLinkHandler';
const defaultLinkCss = "d16qfg52";

/**
 * CustomLink component handles both regular links and special app:// protocol links.
 *
 * This component checks if the href starts with 'app://' and routes it to the appropriate
 * badge component based on the protocol.
 *
 * @param {Object} props - Component props
 * @param {string} props.href - The link URL
 * @param {React.ReactNode} props.children - The link content
 * @param {Object} [props.analyticsHandlers] - Analytics handlers for tracking events
 *
 * @returns {JSX.Element} A badge component, regular link, or disabled link component for malformed app:// links
 */

export const CustomLink = ({
  href,
  children,
  analyticsHandlers
}) => {
  // Convert children to text for app link handling
  const text = typeof children === 'string' ? children : children?.toString() || '';

  // Try to handle as app:// link first
  const appLinkComponent = handleAppLink(href, text, analyticsHandlers);
  if (appLinkComponent) {
    return appLinkComponent;
  }

  // Fallback to default link
  const onClick = () => {
    if (typeof analyticsHandlers?.trackNavigationLinkInChatClicked === 'function') {
      analyticsHandlers.trackNavigationLinkInChatClicked('general_link');
    }
    window.open(href, '_blank', 'noopener,noreferrer');
  };
  return <MinimalButton onClick={onClick}>
      <div className={defaultLinkCss}>
        {children}
        <ArrowExpandIcon />
      </div>
    </MinimalButton>;
};

require("./CustomLink.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CustomLink.js");